// assets
import { UserOutlined, PlusOutlined, EditOutlined, InfoCircleOutlined } from '@ant-design/icons';
import PersonIcon from '@mui/icons-material/Person';

// icons
const icons = {
  UserOutlined,
  PlusOutlined,
  EditOutlined,
  InfoCircleOutlined,
  PersonIcon
};

// ==============================|| MENU ITEMS - USER ROUTES ||============================== //

const UserRoutes = {
  id: 'user-group',
  title: 'Users',
  type: 'group',
  children: [
    {
      id: 'user-list',
      title: 'User List',
      type: 'item',
      url: '/users/list',
      icon: icons.PersonIcon,
      target: false
    }
  ]
};

export default UserRoutes;
